import React from "react";
import style from "./Contacto.module.css";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import { useMediaQuery } from "@material-ui/core";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";

import { Link } from "react-router-dom";
import Button from "@mui/material/Button";

export const Contacto = () => {
  const mobile = useMediaQuery("(max-width:768px)");
  return (
    <div
      id="Contacto"
      className={!mobile ? style.container : style.containerMob}
    >
      <div className={!mobile ? style.item1 : style.item1Mob}>
        <div className={!mobile ? style.txtcont : style.txtcontMob}>
          <h1 className={!mobile ? style.title : style.titleMob}>
            {" "}
            Contáctanos{" "}
          </h1>

          <p className={style.text}>
            Estamos para escucharte.
            Déjanos tu mensaje y con gusto te responderemos a la mayor brevedad posible.
          </p>

          <div className={!mobile ? style.iconCont : style.iconContMob}>
            <Link to="" className={style.link}>
              <WhatsAppIcon className={!mobile ? style.icon : style.iconMob}>
                {" "}
              </WhatsAppIcon>{" "}
            </Link>
            <Link to="" className={style.link}>
              {" "}
              <FacebookIcon className={!mobile ? style.icon : style.iconMob}>
                {" "}
              </FacebookIcon>{" "}
            </Link>
            <Link to="" className={style.link}>
              {" "}
              <InstagramIcon className={!mobile ? style.icon : style.iconMob}>
                {" "}
              </InstagramIcon>{" "}
            </Link>
            <Link to="" className={style.link}>
              {" "}
              <MailOutlineIcon className={!mobile ? style.icon : style.iconMob}>
                {" "}
              </MailOutlineIcon>{" "}
            </Link>
          </div>
        </div>
      </div>

      <div className={!mobile ? style.item2 : style.item2Mob}>
        <Box
          className={style.form}
          component="form"
          sx={{
            "& > :not(style)": { m: 1 },
          }}
          noValidate
          autoComplete="off"
        >
          <TextField
            className={style.inputs}
            id="standard-basic"
            placeholder="Nombre..."
            variant="standard"
            size="large"
          />

          <TextField
            className={style.inputs}
            id="standard-basic"
            placeholder="Correo..."
            variant="standard"
          />

          <TextField
            id="standard-basic"
            placeholder="Teléfono..."
            variant="standard"
            className={style.inputs}
          />

          <TextField
            id="standard-basic"
            placeholder="Empresa..."
            variant="standard"
            className={style.inputs}
          />
          <TextField
            multiline
            rows={4}
            id="standard-basic"
            placeholder="¿Con qué te podemos ayudar?"
            variant="standard"
            className={style.inputs}
          />
        </Box>
        <div className={!mobile ? style.btnCont : style.btnContMob}>
          <Button
            variant="outlined"
            className={!mobile ? style.btn1 : style.btn1Mob}
          >
            Borrar todo
          </Button>
          <Button variant="contained" className={style.btn2}>
            Enviar
          </Button>
        </div>
      </div>
    </div>
  );
};
